import { useMemo } from "react";
import { Flex, Text } from "@chakra-ui/layout";
import moment from "moment";
import { VotacaoItem } from "core/features/assembleia/typings";
import { Switch } from "@chakra-ui/switch";
import { showErrorAxios } from "infra/helpers/alerta";
import { useCallback } from "react";
import useToggleAssembleiaStatus from "core/features/assembleia/hooks/useToggleAssembleiaStatus";
import { AiOutlineClockCircle } from "react-icons/ai";
import { IoCalendarOutline } from "react-icons/io5";
import { Tag } from "@chakra-ui/react";

function useListagemAssembleiaColumns({
  onToogled,
}: {
  onToogled: () => void;
}) {
  const { isLoading, mutate: handleToggleStatus } = useToggleAssembleiaStatus();

  const _handleToggleStatus = useCallback(
    (id: string, checked: boolean) => {
      handleToggleStatus(
        { nextStatus: checked, id },
        {
          onError: (e) => {
            showErrorAxios(e, "Não foi possível alterar o status da votação.");
          },
          onSuccess: () => {
            onToogled();
          },
        }
      );
    },
    [handleToggleStatus, onToogled]
  );

  return useMemo(() => {
    return [
      {
        title: "Enquete",
        render: (nome: string) => (
          <Text>{nome}</Text>
        ),
        dataIndex: "nome",
      },
      {
        title: "Data",
        render: (original: VotacaoItem) => (
          <Flex alignItems="center">
            <IoCalendarOutline />
            <Text ml="8px" >
              {moment(original.dataInicio).format("DD/MM/YYYY")}
            </Text>
          </Flex>
        ),
      },
      {
        title: "Hora de Inicio",
        render: (original: VotacaoItem) => (
          <Flex alignItems="center">
            <AiOutlineClockCircle />
            <Text ml="8px" >
              {moment(`1979-01-01 ${original.horaInicio}`).format("HH:mm")}
            </Text>
          </Flex>
        ),
      },
      {
        title: "Status",
        onClick: () => {},
        render: (original: VotacaoItem) => (
          <div>
            <Switch
              isDisabled={isLoading}
              onChange={() => {
                _handleToggleStatus(original.id, !original.ativo);
              }}
              isChecked={!!original.ativo}
            />
          </div>
        ),
      },
      {
        title: "Procurações",
        onClick: () => {},
        render: (original: VotacaoItem) => (
          <div>
            {original.numeroProcuracoes?.pendente ? (
              <Tag
                h="32px"
                w="120px"
                display="flex"
                justifyContent="center"
                colorScheme="red"
                variant="outline"
                rounded="full"
                textAlign="center"
                py={2}
              >
                {original.numeroProcuracoes?.pendente ?? 0}{" "}
                {original.numeroProcuracoes?.pendente === 1
                  ? "pendente"
                  : "pendentes"}
              </Tag>
            ) : original.numeroProcuracoes?.analise ? (
              <Tag
                h="32px"
                w="120px"
                display="flex"
                justifyContent="center"
                variant="outline"
                colorScheme="orange"
                rounded="full"
                textAlign="center"
                py={2}
              >
                {original.numeroProcuracoes?.analise ?? 0} em análise
              </Tag>
            ) : null}
          </div>
        ),
      },
    ];
  }, [_handleToggleStatus, isLoading]);
}

export default useListagemAssembleiaColumns;
